import { useEffect, useId, useState } from "react";
import { DownOutlined } from "@ant-design/icons";

export const SidebarSection = ({
  title,
  children,
  defaultCollapsed = false,
  storageKey,
}) => {
  const contentId = useId();
  const [collapsed, setCollapsed] = useState(() => {
    if (!storageKey) return defaultCollapsed;

    const stored = localStorage.getItem(storageKey);
    if (stored === "true") return true;
    if (stored === "false") return false;
    return defaultCollapsed;
  });

  useEffect(() => {
    if (!storageKey) return;
    localStorage.setItem(storageKey, String(collapsed));
  }, [collapsed, storageKey]);

  return (
    <section className={`vn-section ${collapsed ? "is-collapsed" : ""}`}>
      <button
        type="button"
        className="vn-section-title"
        aria-expanded={!collapsed}
        aria-controls={contentId}
        onClick={() => setCollapsed((current) => !current)}
      >
        <span>{title}</span>
        <DownOutlined className="vn-section-chevron" />
      </button>
      <div className="vn-section-content" id={contentId} hidden={collapsed}>
        {children}
      </div>
    </section>
  );
};
